<template>
    <div v-if="type === 'divider'" class="divider"></div>
    <button
        v-else
        :class="{
            'richText__menu-item': true,
            active: buttonIsActive(),
        }"
        @click="action"
        :title="title"
    >
        <svg
            :class="{
                remix: true,
                active: buttonIsActive(),
            }"
        >
            <use :xlink:href="`${remixiconUrl}#ri-${icon}`" />
        </svg>
    </button>
</template>

<script>
import { defineComponent } from "vue";
import remixiconUrl from "remixicon/fonts/remixicon.symbol.svg";

export default defineComponent({
    props: {
        editor: {
            type: Object,
            required: true,
        },
        icon: {
            type: String,
            required: false,
        },
        title: {
            type: String,
            required: false,
        },
        action: {
            type: Function,
            required: false,
        },
        type: {
            type: String,
            required: false,
        },
    },

    data() {
        return {
            remixiconUrl,
        };
    },

    methods: {
        buttonIsActive() {
            if (!this.icon) return false;

            switch (this.icon) {
                case "bold":
                    return this.editor.isActive("bold");
                case "italic":
                    return this.editor.isActive("italic");
                case "underline":
                    return this.editor.isActive("underline");
                case "align-left":
                    return this.editor.isActive({ textAlign: "left" });
                case "align-center":
                    return this.editor.isActive({ textAlign: "center" });
                case "align-right":
                    return this.editor.isActive({ textAlign: "right" });
                case "align-justify":
                    return this.editor.isActive({ textAlign: "justify" });
                case "h-1":
                    return this.editor.isActive("heading", { level: 1 });
                case "h-2":
                    return this.editor.isActive("heading", { level: 2 });
                case "h-3":
                    return this.editor.isActive("heading", { level: 3 });
                case "h-4":
                    return this.editor.isActive("heading", { level: 4 });
                case "text":
                    return this.editor.isActive("paragraph");
                case "list-unordered":
                    return this.editor.isActive("bulletList");
                case "list-ordered":
                    return this.editor.isActive("orderedList");
                case "mark-pen-line":
                    return this.editor.isActive("highlight");
                default:
                    return false;
            }
        },
    },
});
</script>

<style scoped>
.divider {
    width: 1px;
    height: 24px;
    background-color: #ccc;
    margin: 0 8px;
}
</style>
